import ApplicationSerializer from 'lumen/serializers/application';

export default class PaRatePreferenceOptionSerializer extends ApplicationSerializer {
  // BE preferred providing us subscriptionId instead of some arbitrary id
  // Use this to tell the store that the "subscriptionId" property can be used as a substitute
  // Note: use the property name as in the API response, not the model property name. So, primaryKey = 'subscriptionId' will not work.
  primaryKey = 'subscription_id';
}
